export default __webpack_public_path__ + "static/media/orangeTheme-boy.cc7bd962.svg";